import React, { useState } from 'react';

function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    interest: '',
    message: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Contato via site — ${form.interest || 'Sem assunto'}`);
    const body = encodeURIComponent(
      `Nome: ${form.name}\nE-mail: ${form.email}\nTelefone: ${form.phone}\nInteresse: ${form.interest}\n\n${form.message}`
    );
    window.location.href = `mailto:contato@hanzol.com.br?subject=${subject}&body=${body}`;
  };

  const inputStyle = {
    width: '100%',
    background: 'transparent',
    border: 0,
    borderBottom: '1px solid rgba(255,255,255,0.2)',
    color: '#fff',
    padding: '14px 0',
    fontSize: '0.95rem',
    outline: 'none',
  };

  return (
    <section
      id="contact"
      className="contact section-padding"
      style={{ background: '#0f0f0f' }}
    >
      <div className="container">
        <div className="sec-head text-center mb-60 wow fadeInUp">
          <h6 className="sub-title main-color mb-15">Vamos conversar</h6>
          <h3
            className="contact-headline"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.2rem)', lineHeight: 1.3, maxWidth: '800px', margin: '0 auto' }}
          >
            Seja para estruturar, ajustar ou escalar o marketing,{' '}
            <span className="main-color">a gente pode te ajudar.</span>
          </h3>
        </div>

        <div className="row lg-marg align-items-stretch">
          <div className="col-lg-7 md-mb50 wow fadeInLeft" data-wow-delay="0.15s">
            <form
              onSubmit={handleSubmit}
              className="contact-form contact-card"
              style={{
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '20px',
                padding: '40px',
                background: 'rgba(255,255,255,0.02)',
              }}
            >
              <div className="row">
                <div className="col-md-6 mb-20">
                  <input
                    type="text"
                    name="name"
                    placeholder="Nome"
                    value={form.name}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div className="col-md-6 mb-20">
                  <input
                    type="email"
                    name="email"
                    placeholder="E-mail"
                    value={form.email}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div className="col-md-6 mb-20">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Telefone"
                    value={form.phone}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div className="col-md-6 mb-20">
                  <select
                    name="interest"
                    value={form.interest}
                    onChange={handleChange}
                    required
                    style={{
                      ...inputStyle,
                      appearance: 'none',
                      cursor: 'pointer',
                      backgroundImage:
                        "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3e%3cpath fill='%23F5C518' d='M6 8L0 0h12z'/%3e%3c/svg%3e\")",
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 5px center',
                    }}
                  >
                    <option value="" style={{ background: '#0f0f0f' }}>
                      Como podemos ajudar?
                    </option>
                    <option
                      value="Quero estruturar meu marketing"
                      style={{ background: '#0f0f0f' }}
                    >
                      Quero estruturar meu marketing
                    </option>
                    <option
                      value="Quero melhorar resultados"
                      style={{ background: '#0f0f0f' }}
                    >
                      Quero melhorar resultados
                    </option>
                    <option
                      value="Quero entender a Hanzol"
                      style={{ background: '#0f0f0f' }}
                    >
                      Quero entender a Hanzol
                    </option>
                  </select>
                </div>
                <div className="col-12 mb-30">
                  <textarea
                    name="message"
                    placeholder="Mensagem"
                    value={form.message}
                    onChange={handleChange}
                    required
                    style={{ ...inputStyle, minHeight: '120px', resize: 'vertical' }}
                  />
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="butn butn-md butn-bg main-colorbg radius-5"
                    style={{ color: '#000', border: 0, cursor: 'pointer' }}
                  >
                    <span className="text" style={{ color: '#000' }}>
                      Enviar
                    </span>
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="col-lg-5 wow fadeInRight" data-wow-delay="0.3s">
            <div
              className="contact-info-card"
              style={{
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '20px',
                padding: '30px',
                background: 'rgba(255,255,255,0.02)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
              }}
            >
              <div
                style={{
                  borderRadius: '14px',
                  overflow: 'hidden',
                  height: '220px',
                }}
              >
                <iframe
                  title="Hanzol localização"
                  src="https://www.google.com/maps?q=Av.+Cabo+Branco,+2332+-+Jo%C3%A3o+Pessoa,+PB&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0, filter: 'grayscale(0.4) invert(0.92) hue-rotate(180deg)' }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <div>
                <h6
                  className="sub-title main-color mb-10"
                  style={{ fontSize: '0.8rem' }}
                >
                  Endereço
                </h6>
                <p style={{ fontSize: '0.95rem', lineHeight: 1.6, margin: 0 }}>
                  Av. Cabo Branco, 2332 — Sala 5
                  <br />
                  João Pessoa, PB
                </p>
              </div>

              <div>
                <h6
                  className="sub-title main-color mb-10"
                  style={{ fontSize: '0.8rem' }}
                >
                  Redes
                </h6>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <a
                    href="https://www.instagram.com/agenciahanzol"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon"
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '50%',
                      border: '1px solid rgba(255,255,255,0.15)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                    }}
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/hanzol-studio/"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon"
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '50%',
                      border: '1px solid rgba(255,255,255,0.15)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                    }}
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
